import {
    TECH_INVENTORY_GET_STARTED,
    TECH_INVENTORY_GET_FINISHED,
    TECH_INVENTORY_GET_FAILED,
    INVENTORY_SEARCH_STARTED,
    INVENTORY_SEARCH_FINISHED,
    INVENTORY_SEARCH_FAILED,
    INVENTORY_TRANSFER_STARTED,
    INVENTORY_TRANSFER_FINISHED,
    INVENTORY_TRANSFER_FAILED,
    SET_INVENTORY_SEARCH_VALUE
} from 'constants/actionTypes';

export const getTechInventoryStarted = (request, userId, timestamp = new Date()) => ({type: TECH_INVENTORY_GET_STARTED, request, userId, timestamp});
export const getTechInventoryFinished = (payload, userId, timestamp) => ({type: TECH_INVENTORY_GET_FINISHED, payload, userId, timestamp});
export const getTechInventoryFailed = (payload, userId, timestamp) => ({type: TECH_INVENTORY_GET_FAILED, payload, userId, timestamp});
export const searchInventoryStarted = (request) => ({type: INVENTORY_SEARCH_STARTED, request});
export const searchInventoryFinished = (payload) => ({type: INVENTORY_SEARCH_FINISHED, payload});
export const searchInventoryFailed = (payload) => ({type: INVENTORY_SEARCH_FAILED, payload});

export const transferInventoryStarted = (request) => ({type: INVENTORY_TRANSFER_STARTED, request});
export const transferInventoryFinished = (payload) => ({type: INVENTORY_TRANSFER_FINISHED, payload});
export const transferInventoryFailed = (error) => ({type: INVENTORY_TRANSFER_FAILED, error});

export const setSearchValue = (value) => ({type: SET_INVENTORY_SEARCH_VALUE, value});


// WEBPACK FOOTER //
// ./src/actions/techInventoryActions.js